import { useState } from "react";
import createPersistedState from "use-persisted-state";

var noop = function noop() {};

var mockElement = {
  classList: {
    add: noop,
    remove: noop
  }
};

var initialize = function initialize(storageKey, storageProvider, glbl) {
  if (glbl === void 0) {
    glbl = global;
  }

  var usePersistedDarkModeState = storageKey ? createPersistedState(storageKey, storageProvider) : useState;
  var mediaQueryEventTarget = null;

  var getInitialValue = function getInitialValue(usersInitialState) {
    return usersInitialState;
  }; // Mock element if SSR else real body element.


  var defaultElement = glbl.document && glbl.document.body || mockElement;

  var getDefaultOnChange = function getDefaultOnChange(element, classNameDark, classNameLight) {
    if (element === void 0) {
      element = defaultElement;
    }

    if (classNameDark === void 0) {
      classNameDark = "dark-mode";
    }

    if (classNameLight === void 0) {
      classNameLight = "light-mode";
    }

    return function (val) {
      element.classList.add(val ? classNameDark : classNameLight);
      element.classList.remove(val ? classNameLight : classNameDark);
    };
  };

  return {
    usePersistedDarkModeState: usePersistedDarkModeState,
    getDefaultOnChange: getDefaultOnChange,
    mediaQueryEventTarget: mediaQueryEventTarget,
    getInitialValue: getInitialValue
  };
};

export default initialize;